/**
 * 自助服务
 */
import { FC, useCallback, useState } from 'react'
import { useTranslation } from "react-i18next";
import { useStoreState } from '@/store'
import css from './index.module.less'
import { Button, Image } from 'antd-mobile'
import { useNav } from '@/hooks/useNav'
import { DownOutline, UpOutline } from 'antd-mobile-icons'
import { useNavigate } from 'react-router-dom'


export const CenterSelf: FC = () => {
  const { t } = useTranslation();
  const { centerConfig }: any = useStoreState();
  const { nav } = useNav();
  const [showMore, setShowMore] = useState(false)
  const navigate = useNavigate()
  const toAddOrderPage = (id) => nav(`/add-order/${id}`);

  const onToggle = useCallback(() => setShowMore(prevState => !prevState), [])

  return (
    <div className={css.SelfService} style={{ display: centerConfig?.centerSelf?.length === 0 ? 'none' : 'block' }}>
      <div className={css.CommonTitle}>
        <span>{t('self-center.title')}</span>
        {centerConfig.centerSelf?.length > 8 && (
          <Button size={'mini'} color={'primary'} fill='none' onClick={onToggle}>
            {showMore ? `${t('self-center.put')}` : `${t('self-center.more')}`}
            {showMore ? <UpOutline /> : <DownOutline />}
          </Button>
        )}
      </div>

      <div className={`${css.BdContent} ${showMore ? css.showMore : ''}`}>
        {centerConfig.centerSelf?.map(cate => (
          <div className={css.BdChunkWrap} key={cate.id}>
            <div className={css.BdChunk} onClick={() => { 
             
              if(cate.serverUrl.includes('.png') || cate.serverUrl.includes('.jpg') || cate.serverUrl.includes('.jpeg')){
                navigate(`/image-show?image=${cate.serverUrl}`)
              }else{
                location.href = cate.serverUrl
              }
              }}>
              <Image className={css.ChunkIcon} src={cate.icon} />
              <div className={`${css.ChunkName} ellipsis-two-lines`}>{cate.serverName}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
